import bookmarkIc from './bookmark.svg';
import cartIc from './cart.svg';
import calendarIc from './calendar.svg';
import libraryIc from './library.svg';
import avatarIc from './avatar.svg';
import booksIc from './books.svg';
import bookOpenIc from './book-open.svg';
import shoppingCartIc from './shopping-cart.svg';
import eyeIc from './eye.svg';
import galleryIc from './gallery.svg';
import magnifyingGlassIc from './magnifying-glass.svg';
import listIc from './list.svg';
import bookmarkSimpleIc from './bookmark-simple.svg';
import bookmarkSimpleActiveIc from './bookmark-simple-active.svg';
import minusCircleIc from './minus-circle.svg';
import plusCircleIc from './plus-circle.svg';
import creditCardIc from './credit-card.svg';
import userCircleIc from './user-circle.svg';
import minusSquareIc from './minus-square.svg';
import plusSquareIc from './plus-square.svg';
import slidersHorizontalIc from './sliders-horizontal.svg';

const IconImages = {
    bookmarkIc,
    cartIc,
    calendarIc,
    libraryIc,
    avatarIc,
    booksIc,
    bookOpenIc,
    shoppingCartIc,
    eyeIc,
    galleryIc,
    magnifyingGlassIc,
    listIc,
    bookmarkSimpleIc,
    bookmarkSimpleActiveIc,
    minusCircleIc,
    plusCircleIc,
    creditCardIc,
    userCircleIc,
    minusSquareIc,
    plusSquareIc,
    slidersHorizontalIc
};

export default IconImages;
